import { Rating, Stack, Typography } from '@mui/material';

export function RatingDisplay({ value, count, size = 'small' }: { value: number; count: number; size?: 'small' | 'medium' }) {
  if (!count) {
    return (
      <Typography variant="body2" color="text.secondary">
        No reviews yet
      </Typography>
    );
  }
  return (
    <Stack direction="row" spacing={0.75} sx={{ alignItems: 'center' }}>
      <Rating value={Number(value)} precision={0.1} readOnly size={size} aria-label={`Rated ${Number(value).toFixed(1)} out of 5`} />
      <Typography variant="body2" sx={{ fontWeight: 600 }}>
        {Number(value).toFixed(1)}
      </Typography>
      <Typography variant="body2" color="text.secondary">
        ({count})
      </Typography>
    </Stack>
  );
}
